"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
// currently we require FC and PWP but this may change to optional in the future
exports.requestSchema = zod_1.z.object({
    lngLat: zod_1.z.string(),
    depthCM: zod_1.z.number(),
    pwp: zod_1.z.number(),
    fc: zod_1.z.number(),
});
exports.responseSchema = zod_1.z.null();
exports.path = '/soil-calibration-settings-set';
//# sourceMappingURL=index.js.map